<template>
  <div class="topic-title-holder">
    <!-- CHANGE TOPIC -->
    <div class="change-topic-holder rounded-20" @click="switchTopicView">
      <span class="icon icon-arrow-left position-relative font-15"></span>
      Change Topic
    </div>

    <div class="d-flex justify-content-between align-items-center nowrap">
      <div>
        <div
          class="topic-title color_text font-weight-bold"
          v-html="title"
        ></div>
        <div class="meta color_text" v-if="title">Select the Questions</div>
      </div>

      <div>
        <router-link :to="{ name: 'TeacherCreateQuestion' }">
          <span
            class="icon-plus flex-center font-20-5 font-weight-500 brand_navy create-button"
          ></span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopicHolder",

  props: {
    title: String,
  },

  methods: {
    switchTopicView() {
      this.$bus.$emit("switchToTopicView");
    },
  },
};
</script>

<style lang="scss" scoped>
.topic-title-holder {
  margin-top: 90px;
  margin-bottom: 10px;
  .topic-title {
    margin-bottom: 2px;
    font-size: 19px;
    line-height: 160%;

    @include breakpoint_max(lg) {
      font-size: 17px;
    }
    @include breakpoint_max(md) {
      font-size: 15px;
    }
    @include breakpoint_max(sm) {
      font-size: 14px;
    }
    @include breakpoint_max(xs) {
      font-size: 12.75px;
    }
  }

  .change-topic-holder {
    padding: 8px 14px;
    margin-bottom: 17px;
    background: darken($color_white, 8%);
    color: $color_ash;
    font-size: 12px;
    cursor: pointer;
    display: none;

    @include breakpoint_max(md) {
      display: table;
    }

    @include breakpoint_max(xs) {
      font-size: 11px;
    }

    .icon {
      margin-right: 5px;
      top: 2px;

      @include breakpoint_max(xs) {
        margin-right: 3px;
      }
    }
  }

  .meta {
    font-size: 14px;
    line-height: 160%;

    @include breakpoint_max(lg) {
      font-size: 13.5px;
    }
    @include breakpoint_max(sm) {
      font-size: 12px;
    }
  }
}

.create-button {
  border-radius: 100%;
  background-color: $brand_accent !important;
  height: 42px;
  width: 42px;

  @include breakpoint_max(xs) {
    height: 33px;
    width: 32px;

    span {
      font-size: 18px;
    }
  }
}
</style>
